import {
  FrontendContextV1,
  type FrontendProduct,
} from "@made-people/nestjs-bff-service";
import { type Product } from "@made-people/grease-product";
import { CentraCheckoutApiProduct } from "@made-people/centra-checkout-api";
import { frontendProductToCheckoutApiProduct } from "./frontend-product-to-checkout-api-product";
import { getCentraCheckoutApiMapperOptions } from "../../centra/mappers/utils/get-centra-mapper-options";
import { mmCentraMappers } from "../../centra/mappers/mm-centra-mappers";
import { applyAllocationRuleToProduct } from "../../centra/allocation-rule/apply-allocation-rule-to-product";

/**
 * FrontedProduct -> CentraCheckoutApiProduct -> Product
 */
export const frontendProductToGreaseProduct = (
  product: FrontendProduct,
  frontendContext: FrontendContextV1,
  allocatedWarehouseIds: string[] | undefined,
): Product => {
  const checkoutApiProduct = frontendProductToCheckoutApiProduct(
    product,
  ) as unknown as CentraCheckoutApiProduct; // double-casting because TS doesn't infer the base type correctly

  const greaseProduct = mmCentraMappers.centraCheckoutApiProductToGreaseProduct(
    checkoutApiProduct,
    getCentraCheckoutApiMapperOptions(frontendContext),
    mmCentraMappers,
  );

  return applyAllocationRuleToProduct(greaseProduct, allocatedWarehouseIds);
};
